// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-q_fQ","galleryThumbnail_active":"c-q_fR","galleryThumbnail__image":"c-q_fS"};